export default function () {
  const wrapperSelector = '.js-color-wrapper';
  const inputSelector = '.js-color-input';
  const pickerSelector = '.js-color-picker';

  const wrapperList = document.querySelectorAll(wrapperSelector);

  for (let i = 0; i < wrapperList.length; i++) {
    const wrapper = wrapperList[i];
    const input = wrapper.querySelector(inputSelector);
    const picker = wrapper.querySelector(pickerSelector);

    if (!input || !picker) {
      continue;
    }

    input.addEventListener('change', () => {
      picker.value = input.value;
    });

    picker.addEventListener('input', () => {
      input.value = picker.value;
    });
  }
}
